import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import { noticeInitData } from "../../constants/notice";
import NoticeRegister from "../../pages/notice/noticeRegister";

const initialState = noticeInitData;

const noticeSlice = createSlice({
  name: "notice",
  initialState,
  reducers: {
    setNoticeRegister: (state: NoticeRegisterType, action: PayloadAction<NoticeRegisterType>) => ({
      ...state,
      ...{
        currentCategory: action.payload.currentCategory ?? state.currentCategory, //공지 카테고리
        title: action.payload.title ?? state.title, //공지 제목
        contents: action.payload.contents ?? state.contents, //공지 내용
        stores: action.payload.stores ?? state.stores, //이행 매장(Real)
        beforeStores: action.payload.beforeStores ?? state.beforeStores, //이행 매장(Temp - 적용시 Real로 이관)
        tempStores: action.payload.tempStores ?? state.tempStores, //그룹 채널 용 이행 매장 (적용시 beforeStores로 이관)
        deleteTempStore: action.payload.deleteTempStore ?? state.deleteTempStore, //그룹 채널 용 이행 매장 (적용시 beforeStores에 제거)
        dateToggle: action.payload.dateToggle ?? state.dateToggle, //마감 일자 유무
        endDate: action.payload.endDate ?? state.endDate, //마감일
        importNotice: action.payload.importNotice ?? state.importNotice, //중요공지 유무
        fileList: action.payload.fileList ?? state.fileList, //첨부파일 리스트
        imageList: action.payload.imageList ?? state.imageList, //이미지 리스트
        limitImage: action.payload.limitImage ?? state.limitImage, //최소 이미지
      },
    }),
    setPlusLimitImage: (state: NoticeRegisterType) => ((state.limitImage || 0) < 30 ? { ...state, limitImage: (state.limitImage || 0) + 1 } : state),
    setMinusLimitImage: (state: NoticeRegisterType) => ((state.limitImage || 0) > 0 ? { ...state, limitImage: (state.limitImage || 0) - 1 } : state),
    setNoticeDataInit: (state: NoticeRegisterType) => initialState,
  },
});

export const { setNoticeRegister, setNoticeDataInit, setPlusLimitImage, setMinusLimitImage } = noticeSlice.actions;

export default noticeSlice.reducer;
